import { getInitialM } from '@shared/helpers/index.ts';
import type { Program } from '@shared/types/programs';

export const getProgramAuthorName = (program: Program) =>
  getInitialM(program?.author.first_name, program?.author.middle_name, program?.author.last_name);

export const onProgramCardClick = (props: {
  onClick: () => void;
  doRedirectWithSavePageUrl: (patch: string) => void;
  url: string;
  event: React.MouseEvent<HTMLDivElement, MouseEvent>;
}) => {
  const { event, onClick, doRedirectWithSavePageUrl, url } = props;
  event.preventDefault();
  onClick();
  doRedirectWithSavePageUrl(url);
};
